// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"22":"f0f731dcdf15aea6","3678":"69a9d3a43a58d012"}[chunkId] + ".css";
};